import { BookCarousel } from "../BookCarousel/BookCarousel";
import { useBooks } from "../../api/client";
import ErrorMessage from "../../../../ui/components/ErrorMessage/ErrorMessage";
interface BookListProps {
  title: string;
  type: 'bestsellerBooks' | 'newcomingBooks';
}

export const BookList: React.FC<BookListProps> = ({ title, type='bestsellerBooks' }) => {
  const { data: bookList, isLoading, error } = useBooks(type, 1, 20, {suspense: true});

  if(error) {
    return(
      <ErrorMessage/>
    )
  }

  return (
    <BookCarousel
      title={title}
      books={bookList?.books ?? []}
      viewAllPath={`/books/${type === "bestsellerBooks"? 'bestsellers' : 'newcomings'}`}
    />
  );
};
